import { render } from "./GravyImageDropdownMenu.vue?vue&type=template&id=59e31cbc&scoped=true"
import script from "./GravyImageDropdownMenu.vue?vue&type=script&lang=js"
export * from "./GravyImageDropdownMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e31cbc"]])

export default __exports__